import AdminHeader from '../../../../Layout/Admin/Header/AdminHeader'
import AdminMobileHeader from '../../../../Layout/Admin/MobileHeader/AdminMobileHeader'
import AdminSidebar from '../../../../Layout/Admin/Sidebar/AdminSidebar'
import React, { FC, ReactNode, useEffect, useState } from 'react'
import './AdminWrapper.scss'
import { TGModalAlert } from '../../../../Components'
import { useDispatch, useSelector } from 'react-redux'
import { SHOW_ALERT } from '../../../../Constants/AppAlertConstants'
import { appAlertType } from 'Reducers/AppAlerts/AppAlertsReducer'
import { useLocation, useNavigate } from 'react-router-dom'
import AdminSideBarContent from '../../../../Layout/Admin/Sidebar/AdminSideBarContent/AdminSideBarContent'
import logo from '../../../../Assets/Images/logo-white.svg'

interface propTypes {
  children: ReactNode
}

const AdminWrapper: FC<propTypes> = ({ children }) => {
  const location = useLocation()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  // MODAL ALERT
  const dispatcher = useDispatch()

  const handleCloseAlertModal = () => {
    dispatcher({ type: SHOW_ALERT, payload: { message: '', title: '', show: false } })
  }

  const appAlert = useSelector((state: { appAlert: appAlertType }) => state?.appAlert)

  useEffect(() => {
    const handleUnload = () => {
      // Clear data from local storage
      // localStorage.removeItem('__TG');
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        // User is inactive, clear data from local storage
        // localStorage.removeItem('__TG');
      }
    }

    window.addEventListener('beforeunload', handleUnload)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.removeEventListener('beforeunload', handleUnload)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  useEffect(() => {
    const checkSession = () => {
      const loginTime = localStorage.getItem('loginTime')
      if (loginTime) {
        const currentTime = Date.now()
        const timeElapsed = currentTime - parseInt(loginTime, 10)
        const twelveHours = 39 * 60 * 60 * 1000 // 39 hours in milliseconds
        // const twelveHours = 10 * 60 * 1000

        if (timeElapsed > twelveHours) {
          logoutUser()
        } else {
          // Set a timer to log out the user exactly after remaining time
          setTimeout(() => {
            logoutUser()
          }, twelveHours - timeElapsed)
        }
      }
    }

    checkSession()
  }, [])

  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [location.pathname])

  useEffect(() => {
    if (!isMobileMenuOpen) return

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsMobileMenuOpen(false)
      }
    }

    window.addEventListener('keydown', handleEscape)

    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener('keydown', handleEscape)
    }
  }, [isMobileMenuOpen])

  const navigate = useNavigate()

  const handleDrawerBodyClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement | null
    if (target?.closest('a.nav-link, button.nav-link')) {
      setIsMobileMenuOpen(false)
    }
  }

  const logoutUser = async () => {
    localStorage.removeItem('__TG')
    localStorage.removeItem('loginTime')

    setTimeout(() => {
      alert('Session Expired')
      navigate('/login')
    }, 2000)
  }

  return (
    <React.Fragment>
      <div className='adminWraper p-0 m-0 w-100'>
        {isMobileMenuOpen && (
          <button
            type='button'
            className='adminWraper__backdrop'
            aria-label='Close navigation menu'
            onClick={() => setIsMobileMenuOpen(false)}
          />
        )}

        <aside
          className={`adminWraper__mobile-drawer ${isMobileMenuOpen ? 'adminWraper__mobile-drawer--open' : ''}`}
        >
          <div className='adminWraper__mobile-drawer-header'>
            <img src={logo} alt='TradeGrid' className='adminWraper__mobile-drawer-logo' />
            <button
              type='button'
              className='adminWraper__mobile-drawer-close'
              aria-label='Close navigation menu'
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <span />
              <span />
            </button>
          </div>

          <div className='adminWraper__mobile-drawer-body' onClick={handleDrawerBodyClick}>
            <AdminSideBarContent />
          </div>
        </aside>

        <div className='row'>
          <div className='col-25 pe-0 '>
            <AdminSidebar></AdminSidebar>
          </div>
          <div className='col-85 p-0'>
            <AdminMobileHeader onMenuClick={() => setIsMobileMenuOpen(true)} />
            <AdminHeader></AdminHeader>
            {children}
          </div>
        </div>
      </div>

      <TGModalAlert
        show={appAlert?.show}
        title={appAlert?.title}
        message={appAlert?.message}
        onClose={handleCloseAlertModal}
        type={appAlert?.type}
      />
    </React.Fragment>
  )
}

export default AdminWrapper
